module.exports = __webpack_public_path__ + "img/pass-recovery-icon.e9560d52.svg";